//@flow

type IconProps = { [string]: string };

export const IconForCards: IconProps = {
  trek: 'icon icon-hg-hiking',
  lodge: 'icon icon-hg-home',
  sighting: 'icon icon-hg-binoculars',
  attraction: 'icon icon-hg-attraction',
  sidetrip: 'icon icon-hg-man-in-hike',
  place: 'icon icon-hg-map-pin',
  flights: 'icon icon-hg-flight',
  guide: 'icon icon-hg-man-in-hike',
};

export const CardOverlayIcon: IconProps = {
  add: 'icon icon-hg-plus',
  remove: 'icon icon-hg-trash',
  view: 'icon icon-hg-eye',
};

//no spaces and all lowercase required in servicename
export const ServicesLodgeDetails: IconProps = {
  bed: 'icon icon-hg-bed',
  breakfast: 'icon icon-hg-bread',
  lunch: 'icon icon-hg-breakfast-odd',
  dinner: 'icon icon-hg-serving-lunch',
  charging: 'icon icon-hg-charger',
  hotshower: 'icon icon-hg-shower-o',
  wifi: 'icon icon-hg-wifi-signal',
  attachedtoilet: 'icon icon-hg-western-toilet',
  toiletpaper: 'icon icon-hg-toilet-paper',
  default: 'icon icon-hg-service-default',
};

export const ProfileIcon: string = 'icon icon-hg-profile-old';

export const TrekOverviewIcon: IconProps = {
  sun: 'icon icon-hg-sun-o',
  group: 'icon icon-hg-group',
};



// WEBPACK FOOTER //
// ./src/constants/icons.js